import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { CourseExports } from '../../../../pages/course-export/CourseExports';

export const Route = createFileRoute('/_private/_home/course-exports/')({
  component: CourseExportsRoute,
});

function CourseExportsRoute() {
  const { apiClient } = Route.useRouteContext();
  return <CourseExports portalApiClient={apiClient} />;
}
